import { render, staticRenderFns } from "./ThemePanel.vue?vue&type=template&id=36c8cc9d"
import script from "./ThemePanel.vue?vue&type=script&lang=js"
export * from "./ThemePanel.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports